@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.modal-content {
  margin: @space-8 @space-0;
}

.loading-indicator {
  height: 60px;
}

.summarize-info {
  display: flex;
}

.with-top-margin {
  margin-top: @space-16;
}

.summarize-info-item {
  width: 100%;
}

.summarize-info-header {
  display: block;
  margin: 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
}

.summarize-info-value {
  display: block;
  margin: 0;
  padding: 0;
  font-size: 1rem;
  font-weight: @normal;
  line-height: 1.5rem;
}

.banner {
  border: 1px solid var(--blue-400);
  border-radius: 0%;
  padding: 6px;
  margin: @space-16 @space-0;
}

.table-body {
  margin-top: @space-16;
  border: 1px solid var(--default--header--border-color--3);
}

.table-column-header {
  border-bottom: 1px solid var(--default--header--border-color--3);
}
